<!--Double navigation-->
<header [ngSwitch]="isAuthenticated">
  <!-- connected navigation -->
  <ng-template [ngSwitchCase]="true">
    <jhi-bary-sidebar
      #barySidebar
      [account]="account!"
      [isImpersonating]="false"
      [inProduction]="inProduction"
      [swaggerEnabled]="swaggerEnabled"
      (goToEvent)="goTo($event)"
      [transporter]="transporter!"
    ></jhi-bary-sidebar>
    <jhi-bary-nav-bar (toggleSideBarEvent)="barySidebar.sidenav.toggle()" (goToEvent)="goTo($event)" [customer]="customer" (logoutEvent)="logout()"></jhi-bary-nav-bar>
  </ng-template>
  <!-- disconnected navigation -->
  <ng-template ngSwitchDefault>
    <jhi-bary-disconnected-nav-bar
      [transporter]="transporter"
      (goToEvent)="goTo($event)"
      (registerEvent)="goTo(PATHS.ACCOUNT_REGISTER.path)"
      (loginEvent)="login()"
    ></jhi-bary-disconnected-nav-bar>
  </ng-template>
</header>
<!--/.Double navigation-->
